import { sendEvent } from '@weee-fe/weee-biz-web';
import { deepMerge } from './utils';
import { NewTracking } from '@/constants/track';
import { formatParam } from '@/tracks/useImpressionT2';
export const shareButtonClick = (params = {} as any) => {
  params = formatParam(params);
  sendEvent({
    type: NewTracking['clickAction'],
    params: deepMerge(
      {
        co: {
          is_select: null,
          is_mkpl: false,
          click_type: 'share',
          click_result: null,
          target_pos: 0,
          target_nm: null
        }
      },
      params
    )
  });
};
